import { lazy } from 'react';

/** Открывает карточку шаблона промобаннера */
export const PromotionBannerTemplateDetailsPageAsync = lazy(() => import('./PromotionBannerTemplateDetailsPage'));
